<template>
    <el-dialog class="advanceCollectionDialog" :title="title" width="40%" :modal-append-to-body="false" :visible.sync="visible" :close-on-click-modal="false" :before-close="handleClose">
        <el-form v-if="visible" disabled ref="form" :model="form" :rules="rules" label-width="130px" size="mini" style="font-size: 14px;">
            <el-form-item label="银行账号" prop="accountName">
                <el-input v-model="form.accountName" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="开户行" prop="bankName">
                <el-input v-model="form.bankName" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="账户名称" prop="bankUserName">
                <el-input v-model="form.bankUserName" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="申请提前收款金额" prop="canPayAmt">
                <el-input v-model="form.canPayAmt" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="现金折扣金额" prop="discountAmt">
                <el-input v-model="form.discountAmt" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="实际收款金额" prop="payAmt">
                <el-input v-model="form.payAmt" placeholder=""></el-input>
            </el-form-item>
        </el-form>
        <div class="notes">
            提示：签约前请仔细阅读<span class="paction">《现金折扣申请书》</span>与<span class="paction">《现金折扣协议》</span>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="handleConfirm">电子签章</el-button>
        </span>

        <!-- 协议弹窗 -->
        <FinalizationDialog ref="finalizationDialogRef" iframeKey="advanceCollectionDialog" @finalizationSuccess="finalizationSuccess"></FinalizationDialog>
    </el-dialog>
</template>

<script>
import FinalizationDialog from './FinalizationDialog.vue';
import { stAi } from '@/modules/transport/bms/components/judge/bmsModular';
export default {
    name: 'advanceCollectionDialog',
    components: { FinalizationDialog },
    data() {
        return {
            title: '提前收款申请',
            visible: false,
            loading: false,
            rules: {
                accountName: [{ required: true, trigger: ['blur'] }]
            },
            form: {
                accountName: '',
                bankName: '',
                bankUserName: '',
                canPayAmt: '',
                taxCode: '',
                discountAmt: '',
                payAmt: '',
                taxRate: ''
            },
            toData: {}
        };
    },
    computed: {
    },
    methods: {
        handleClose() {
            this.visible = false;
            this.clear();
        },
        handleVisible(flag, data) {
            this.visible = !!flag;
            this.form = stAi(data, this.form);
            this.toData = JSON.parse(JSON.stringify(data));
        },
        handleVerify(callback) {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    callback();
                }
            });
        },
        handleConfirm() {
            this.$refs.finalizationDialogRef.handleVisible(true, JSON.parse(JSON.stringify(this.toData)));
        },

        clear() {
            this.$refs['form'].clearValidate();
            this.$refs['form'].resetFields();
        },

        dialogConfirm() {
            const fieldArr = ['preferentialPolicyType', 'taxRate'];
            const onSuccess = () => {
            };
            const isEmptyVal = fieldArr.some(field => !this.form[field]);
            fieldArr.map(field => {
                this.$refs.form.validateField(field, (errorMessage) => {
                    if (!isEmptyVal) {
                        onSuccess();
                    } else {
                        return false;
                    }
                });
            });
        },
        setFormData(key, val) {
            Object.hasOwnProperty.call(this.form, key) ? this.form[key] = val : this.$set(this.form, key, val);
        },
        finalizationSuccess() {
            this.visible = false;
            this.$emit('finalizationSuccess');
        }

    },
    created() {

    }
};
</script>
<style lang="less">
.advanceCollectionDialog {

    .dialog-region-select {
        input {
            width: 100%;
            margin-right: 32px;
        }
        .el-input__suffix {
            right: 35px;
        }
    }
    .nobottom-form-item {
        margin-bottom: 0;
    }
    .el-select{
        width: 160px !important;
    }

    .notes{
        width: 100%;
        display: flex;
        justify-content: center;
        padding-top: 20px;
        .paction{
            color:#00BCBF;
            cursor: pointer;
        }
    }
}
.el-form-item.is-success .el-input__inner{
    border-color:#00BCBF !important;
}
</style>
